module.exports = __webpack_public_path__ + "img/Genius.d84af4dc.png";